module.exports = __webpack_public_path__ + "img/4.88628b3c.png";